export default "__VITE_PUBLIC_ASSET__7d51584d__"